import { render, staticRenderFns } from "./ItemDetailBase.vue?vue&type=template&id=9f28f3c2&scoped=true&"
import script from "./ItemDetailBase.vue?vue&type=script&lang=js&"
export * from "./ItemDetailBase.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetailBase.vue?vue&type=style&index=0&id=9f28f3c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f28f3c2",
  null
  
)

export default component.exports